<template>
    <div class="walk-in">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <input type="text" name="" id="" v-model="faculty">
                    <qrcode-stream @decode="onDecode"></qrcode-stream>
                    <p>{{decodeText}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue"
import BootstrapVue from "bootstrap-vue"
import axios from 'axios'
import { mapActions } from 'vuex'
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  name: 'walkin',
  components: {
    QrcodeStream
  },
  data() {
      return {
          faculty: "",
          decodeText: "รอการสเเกน",
          lastScanUser: "",
          url: "https://us-central1-oph2019-kmitl-c2dac.cloudfunctions.net/event/walkin/"
      }
  },
  methods: {
        onDecode(decodeString) {
            this.decodeText = "กำลังสเเกน"
            let regex = /(https:\/\/oph2019-kmitl-c2dac.)(firebaseapp.com|web.app)\/profile\?user=K([0-9]){5}&password=([A-Za-z0-9])+/g
            console.log(decodeString)

            if (regex.test(decodeString)) {
                let params = decodeString.split('?')[1].split('&')
                let user = params[0].split('=')[1], pass = params[1].split('=')[1]
                this.lastScanUser = user
                axios({
                    method: "POST",
                    url: this.url+this.faculty,
                    data: {
                        id: user,
                        day: "23"
                    }
                })
                .then((res) => {
                    this.decodeText = res.data.message
                })
                .catch((err) => {
                    console.log(err)
                })
            }

            
        }
  }
}
</script>
